import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import './styles/index.css';
import 'amfe-flexible';

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
